import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface HookProps {
  batchId: string;
  fileName: string;
}

export const useDownloadOriginalFileFromCloud = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ batchId, fileName }: HookProps) => {
      const response = await request({
        path: `batches/${batchId}/download`,
        method: 'POST',
        authenticate: true,
        fileDownload: true,
      });
      const href = window.URL.createObjectURL(response);
      const link = document.createElement('a');
      link.href = href;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['batches'] });
      toast.success('Successfully downloaded the original file!');
    },
    onError: (error) => {
      showErrorToast(error, 'Error downloading the original file!');
    },
  });
};
